module.exports = __webpack_public_path__ + "img/1543735048.786bbd04.jpg";